import Sidebar from 'pages/sideBar/SideBar';
import React, { useEffect, useState, useMemo } from 'react';
import '../app.css';
import imgReviews from '../../../../assets/images/order.png';
import ActiveOrders from 'components/orderComponets/ActiveOrders';
import PastOrdersIMg from '../../../../assets/images/pastorder.png';
import axios from 'axios';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import NoDataImage from '../../../../assets/images/nodataImg.png';

const apiURL = 'https://backend.washta.com/api/seller/pastorder';

function OrderDashbaord() {
  const [data, setData] = useState([]);
  const [pastorderdata, setpastorderdata] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- UPDATED FILTER STATE (Single Date) ---
  const [filters, setFilters] = useState({
    search: '',
    status: 'all',
    date: '' // Single date instead of range
  });

  const fetchData = async () => {
    const token = localStorage.getItem('accessToken');
    const apiUrl = 'https://backend.washta.com/api/seller/latestOrders';
    try {
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(response.data.data);
    } catch (err) {
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchpastorder = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios.get(apiURL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setpastorderdata(response.data.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
    fetchpastorder();
  }, []);
  const applyFilters = (ordersList) => {
    if (!ordersList) return [];
    
    return ordersList.filter((item) => {
      if (item.billingStatus === "non-paid") return false;
      const searchStr = filters.search.toLowerCase();
      const orderIdStr = item._id ? String(item._id).toLowerCase() : "";
      const promoCodeStr = item.promoCode ? String(item.promoCode).toLowerCase() : "";
      const shopNameStr = item.shopId?.shopName ? String(item.shopId.shopName).toLowerCase() : "";

      const matchesSearch = filters.search === '' || 
        orderIdStr.includes(searchStr) || 
        promoCodeStr.includes(searchStr) ||
        shopNameStr.includes(searchStr); // Added shopName search

     let matchesStatus = true;

if (filters.status !== 'all') {
  if (filters.status === 'expired') {
    matchesStatus = item.isExpired === true;
  } 
  else if (filters.status === 'ongoing') {
    matchesStatus = item.status === 'ongoing' && item.isExpired !== true;
  } 
  else {
    matchesStatus = item.status === filters.status;
  }
}

      // 4. DATE LOGIC (Single day match)
      let matchesDate = true;
      if (filters.date) {
        const orderDate = new Date(item.createdAt).toISOString().split('T')[0];
        matchesDate = orderDate === filters.date;
      }

      return matchesSearch && matchesStatus && matchesDate;
    });
  };

  const filteredActive = useMemo(() => applyFilters(data), [data, filters]);
  const filteredPast = useMemo(() => {
    const filtered = applyFilters(pastorderdata);
    return filtered.filter(item => item.status === 'completed');
  }, [pastorderdata, filters]);

  const updateOrderStatus = async (id, status) => {
    const token = localStorage.getItem('accessToken');
    const url = `https://backend.washta.com/api/seller/orderStatus/${id}`;
    try {
      await axios.patch(url, { id, status }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchData();
      fetchpastorder();
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };
  return (
    <div className='mainDiv-all-sideBar'>
      <div className='div-sidebar'>
        <Sidebar />
      </div>
      <div className='div-Dashbaord'>
        <h1 className='h1-all-heading'>Orders</h1>

        {/* --- FILTER UI BAR --- */}
        <div className="filter-container" style={{ 
          display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '20px', 
          background: '#fff', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        }}>
          <input
            type="text"
            placeholder="Search Order ID or Shop Name ..."
            name="search"
            value={filters.search}
           className="customPlaceholder"
            onChange={handleFilterChange}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd', flex: '1',width:'250px' }}
          />
          
          <select 
            name="status" 
            value={filters.status} 
            onChange={handleFilterChange}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd', minWidth: '150px' }}
          >
            <option value="all">All Statuses</option>
            <option value="ongoing">Ongoing</option>
            <option value="inprocess">In Process</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
            <option value="expired">Expired</option> Added Expired
          </select>

          <input 
            type="date" 
            name="date" 
            value={filters.date} 
            onChange={handleFilterChange}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd',width:'200px' }}
          />

          <button 
            onClick={() => setFilters({search: '', status: 'all', date: ''})}
            style={{ padding: '8px 15px', borderRadius: '4px', border: 'none', background: '#747EEF', color: '#fff', cursor: 'pointer' }}
          >
            Clear Filters
          </button>
        </div>

        <div className="dashboard">
          <div className='styles-div-order'>
            {/* ACTIVE ORDERS */}
            <div className='invoice-border'>
              <div className='chart-colm-div-heading'>
                <img src={imgReviews} style={{ width: '1.5em', objectFit: 'contain' }} alt="icon" />
                <h2 className='main-heading2'>Active Orders ({filteredActive.length})</h2>
              </div>
              <div className='row-details-order'>
                {loading ? <LoadingSkeleton /> : filteredActive.length === 0 ? (
                  <NoDataView />
                ) : (
                  filteredActive.map((item) => (
                    <div key={item._id} style={{ position:'relative'}}>
                      <ActiveOrders
                        data={item}
                        Accpet={() => updateOrderStatus(item._id, 'inprocess')}
                        Refuse={() => updateOrderStatus(item._id, 'cancelled')}
                        Complete={() => updateOrderStatus(item._id, 'completed')}
                        Price={parseFloat(item?.cost)}
                        billingStatus={item.billingStatus}
                        status={item.status}
                        orderlocation={item?.location?.text || 'Location not provided'}
                        timer={item.timer}
                        promoCode={item.promoCode}
                      />
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* COMPLETED ORDERS */}
            <div className='invoice-border'>
              <div className='chart-colm-div-heading'>
                <img src={PastOrdersIMg} style={{ width: '1.5em', objectFit: 'contain' }} alt="icon" />
                <h2 className='main-heading2'>Completed Orders ({filteredPast.length})</h2>
              </div>
              <div className='row-details-order'>
                {loading ? <LoadingSkeleton /> : filteredPast.length === 0 ? (
                  <NoDataView />
                ) : (
                  filteredPast.map((item) => (
                    <div key={item._id} style={{ flex: '1 1 calc(33% - 16px)', position:'relative' }}>
                      <ActiveOrders
                        showMarkButton={false}
                        data={item}
                        Price={parseFloat(item?.cost)}
                        billingStatus={item.billingStatus}
                        status={item.status}
                        orderlocation={item?.location?.text || 'Location not provided'}
                        timer={item.timer}
                        promoCode={item.promoCode}
                      />
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Sub-components for cleaner code
const LoadingSkeleton = () => (
  <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
    {Array.from(new Array(3)).map((_, index) => (
      <Skeleton variant="rectangular" width="32%" height={180} key={index} sx={{ borderRadius: 3 }} />
    ))}
  </Box>
);

const NoDataView = () => (
  <div style={{width:'100%', justifyContent:'center', display:'flex', padding: '20px'}}>
    <img src={NoDataImage} alt="No Data" style={{ maxWidth: '250px', opacity: 0.7 }} />
  </div>
);

export default OrderDashbaord;